import { useLingui } from '@lingui/react'
import { type FC } from 'react'

import { type CartControllerRedPointsPossibleDiscountsV2 } from 'types/api/cart'
import { type PublicRuntimeConfig } from 'types/shopConfig'
import {
  currencyToSymbol,
  formatPriceString,
} from 'views/components/atoms/Price/helpers'
import Select from 'views/components/molecules/Select'
import withShopAndRuntimeConfig from 'views/enhancers/withShopAndRuntimeConfig'

interface RedPointsSelectProps {
  redPointsDiscounts: CartControllerRedPointsPossibleDiscountsV2[]
  publicRuntimeConfig: PublicRuntimeConfig
  selectedRedPoints: number
  hasDiscounts: boolean
  onChange: (value: number) => void
}

const RedPointsSelect: FC<RedPointsSelectProps> = ({
  onChange,
  redPointsDiscounts,
  selectedRedPoints,
  hasDiscounts,
  publicRuntimeConfig: {
    publicConfig: { locale, currency },
  },
}) => {
  const { i18n } = useLingui()
  const rpVoucherSelectOptions = [
    ...redPointsDiscounts.map(discount => {
      const valueInEuro = formatPriceString({
        amount: discount.discountCents / 100,
        locale,
        currencySymbol: currencyToSymbol(currency),
        decimalPlaces: 2,
        symbolRight: false,
      })

      return {
        value: discount.pointsToRedeem,
        text: `${discount.pointsToRedeem.toLocaleString(
          locale
        )} = ${valueInEuro}`,
        disabled: discount.pointsToRedeem === 0 && !hasDiscounts,
      }
    }),
  ]

  const selectRedeemableVouchers = {
    id: 'selectRedeemableVouchers',
    name: 'selectRedeemableVouchers',
    label: i18n._('cart.redPointsBox.select.label'),
    showLabel: false,
    options: rpVoucherSelectOptions,
    className: 'o-RedeemRedPoints__input',
    selectedValue: selectedRedPoints,
    disabled: !hasDiscounts,
  }

  return (
    <Select
      {...selectRedeemableVouchers}
      onChange={(event: { target: { value: number } }) =>
        onChange(event.target.value)
      }
      dataQa="cart-redPointsBox-select"
    />
  )
}

export default withShopAndRuntimeConfig(RedPointsSelect)
